import { Row, defaultGroupByFn } from 'react-table';

import { getGroupByMatchState } from '@trqk/utils';

import { COLUMN_IDS, summarizeRowsAbove } from '../constants';

const groupByMatchState =
    getGroupByMatchState<GapReportAudio>(summarizeRowsAbove);

/**
 * Group rows based on the column ID.
 * - when grouping by column IDs other than the Track Name column ID, use the defaultGroupByFn
 * - for the Track Name column ID, group rows based on whether they have been matched to a statement
 *      work.
 *      - if a row has been matched to a statement work, and that statement work has been matched to
 *      more than once, it is grouped by the matched_work_id
 *      - otherwise, it is grouped by the gap_audio_id
 * @param rows - table rows
 * @returns an object where each key is a grouped row ID and each value is an array of grouped rows
 */
export const groupTrackNameByMatchState = (
    rows: Row<GapReportAudio>[],
    columnId: string,
): Record<string, Row<GapReportAudio>[]> => {
    if (columnId !== COLUMN_IDS.TRACK_NAME) {
        return defaultGroupByFn(rows, columnId);
    }

    return groupByMatchState(rows);
};
